export default {"src":"/_next/static/media/MORALIS.1869f888.svg","height":39,"width":161,"blurWidth":0,"blurHeight":0};